// extracted by mini-css-extract-plugin
module.exports = {"app-nav":"AppNavigation_app-nav__1P4-F","app-links":"AppNavigation_app-links__SFPYO","link-active":"AppNavigation_link-active__12LuU"};